import React from 'react'
import { Link, useLocation } from 'react-router-dom';

function BottomNavigationCustomer() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/customer-home-page', label: 'Home', iconOn: 'bi-house-door-fill', iconOff: 'bi-house-door' },
    { path: '/customer-activity', label: 'My Cases', iconOn: 'bi-file-earmark-text-fill', iconOff: 'bi-file-earmark-text' },
    // { path: '/all-offers', label: 'Offers', iconOn: 'bi-tag-fill', iconOff: 'bi-tag' },
    { path: '/user-profile-section', label: 'Profile', iconOn: 'bi-person-fill', iconOff: 'bi-person' },
  ];

  return (
    <>
      {/* Injected styles inside JSX */}
      <style>{`
        .cp-nav-bar {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 999;
          height: 68px;
          background: #ffffff;
          border-top: 1px solid #eef2f6;
          box-shadow: 0 -4px 16px rgba(20, 43, 77, 0.06);
          display: flex;
          align-items: center;
          justify-content: space-around;
          padding-bottom: env(safe-area-inset-bottom, 0px);
        }

        .cp-nav-item {
          flex: 1;
          height: 100%;
        }

        .cp-nav-item .none {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .cp-nav-tab {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          color: #9aa6b6;
        }

        .cp-nav-tab i {
          font-size: 20px;
          color: inherit;
        }

        .cp-nav-tab span {
          font-size: 11px;
          font-weight: 600;
          color: inherit;
          line-height: 1;
        }

        .cp-nav-item.active .cp-nav-tab {
          color: #176fe8;
        }

        @media (min-width: 600px) {
          .cp-nav-bar { height: 74px; }
          .cp-nav-tab i { font-size: 22px; }
          .cp-nav-tab span { font-size: 12px; }
        }
      `}</style>

      {/* Footer */}
      <nav className="cp-nav-bar font-satoshi">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <div className={`cp-nav-item ${active ? 'active' : ''}`} key={item.path}>
              <Link className="none" to={item.path}>
                <div className="cp-nav-tab">
                  <i className={`bi ${active ? item.iconOn : item.iconOff}`}></i>
                  <span>{item.label}</span>
                </div>
              </Link>
            </div>
          );
        })}
      </nav>
    </>
  );
}

export default BottomNavigationCustomer;